import type { VerdictTier } from './reportVerdict';

/** Short BTM tier labels (at-a-glance chips, tooltips). */
const BTM_TIER_LABELS: Record<Exclude<VerdictTier, 'none'>, string> & { none: string } = {
  green: 'High Feasibility',
  amber: 'Moderate Risk',
  red: 'High Risk / Blocked',
  none: '—',
};

/** Per-site BTM legend rows for the dashboard portfolio map. */
export const BTM_SITE_MAP_LEGEND_ITEMS = [
  { tier: 'green' as const, label: 'Site · High BTM Feasibility', dotClass: 'bg-success' },
  { tier: 'amber' as const, label: 'Site · Moderate BTM Risk', dotClass: 'bg-warning' },
  { tier: 'red' as const, label: 'Site · High BTM Risk / Blocked', dotClass: 'bg-danger' },
] as const;

/** @deprecated Use BTM_SITE_MAP_LEGEND_ITEMS for map surfaces. */
export const BTM_STRATEGY_MAP_LEGEND_ITEMS = BTM_SITE_MAP_LEGEND_ITEMS;

export function btmStrategyTierLabel(tier: VerdictTier): string {
  return BTM_TIER_LABELS[tier] ?? '—';
}

/** Pin colors aligned with map legend tiers (Google Maps Pin API). */
export function pinColorsForVerdictTier(tier: VerdictTier): { background: string; borderColor: string } {
  switch (tier) {
    case 'green':
      return { background: '#22c55e', borderColor: '#15803d' };
    case 'amber':
      return { background: '#f59e0b', borderColor: '#b45309' };
    case 'red':
      return { background: '#ef4444', borderColor: '#b91c1c' };
    default:
      return { background: '#64748b', borderColor: '#334155' };
  }
}
